export default {
  featuredExperiences: '精選體驗',
  searchAllExperiences: '搜尋所有體驗',
  searchAll: '搜尋全部',
  groupSize: '團體人數',
  eventSize: '活動人數',
  upTo: '最多',
  whatWeDo: '我們將會做什麼',
  hostedBy: '由...主辦',
  whatsIncluded: '包含內容',
  avail: '可預約情況',
  whereWeAre: '我們將會在哪裡',
  experienceCalendar: '體驗日曆',
  experienceCancelled: '體驗已取消',
  experienceStartingPrice: '起價 {{price}}',
  experienceTotalPrice: '總價 {{price}}',
  at: '於',
  viewPrivateSessAvailability: '查看私人場次可預約情況',
  selectDuration: '選擇時長',
  selectStartTime: '選擇開始時間',
  selectSession: '選擇場次',
  sessionsCount: '{{count}}個時間 — 選擇時間',
  noAvailability: '無可預約時間',
  select: '選擇',
  slotLeft: '剩餘 {{remainSlots}} 個名額',
  slotsLeft: '剩餘 {{remainSlots}} 個名額',
  spotsLeft: '剩 {{count}}',
  spotsLeftAriaLabel: '剩 {{count}} 個位置',
  bookExperience: '預訂體驗',
  book: '預訂',
  learnMore: '了解更多',
  apply: '套用',
  maxPartySizes: '每組最多 {{maxGroupSize}} 人',
  maxPartySize: '每組最多 {{maxGroupSize}} 人',
  selectSessionValidation: '請選擇場次',
  selectParticipantValidation: '請選擇參與者',
  selectDateValidation: '請選擇日期',
  reminders: '提醒事項',
  seeOtherDates: '查看其他日期',
  location: '地點',
  about: '關於',
  allExperiences: '所有體驗',
  soldOut: '已售罄',
  reviews: '評論',
  reviewSingular: '則評論',
  reviewPlural: '則評論',
  dateOfExperience: '體驗日期',
  readLess: '收起',
  readMore: '閱讀更多',
  seeMore: '查看更多',
  details: '詳細資訊',
  durationHour: '小時',
  durationHours: '小時',
  durationMinutes: '分鐘',
  theFollowingVideoDoesNotContainAnyAudio: '以下影片無聲音',
  by: '由',
  chooseATime: '為 {{title}} 選擇時間',
  amenities: '設施',
  ticketSalesOpenIn: '距離開賣還有',
  ticketSalesOpen: '售票已開啟',
  ticketSalesCloseIn: '距離售票結束還有',
  ticketSalesClose: '售票已結束',
  ticketSalesClosed: '售票已結束',
  comingSoon: '即將推出',
  inPartnershipWith: '合作夥伴',
  notFoundExperienceTitle: '此體驗已不可用',
  notFoundExperienceSubtitle: '可能已取消發布，或連結已失效。',
  deadLinkRecoverySubtitle: '探索可預訂的其他體驗',
  viewAllExperiences: '查看所有體驗',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p>登入您的凱悅天地賬戶預訂體驗，每 1 美元認可消費可<strong>獲享 5 點基本積分</strong></p>',
      basePoints:
        '<p>登入您的凱悅天地賬戶預訂體驗，每 1 美元認可消費可<strong>獲享 10 點基本積分</strong></p>',
      additionalBonusPoints:
        '<p>使用凱悅天地信用卡進行預訂，每 1 美元認可消費可<strong>額外獲享 4 點獎勵積分</strong></p>',
      additionalBonusPointsTier:
        '<p>根據您的會籍級別，還可<strong>獲享高達 30% 的額外</strong>獎勵積分</p>',
      payWithPoints: '<p>預訂體驗時，<strong>可使用積分支付</strong></p>',
    },
  },
};
